import { ImprovementOrigin, ImprovementStatus, QualityRiskStatus } from '@zeus/index'

/** Libellés de l'amélioration continue (#328), partagés par l'écran et les CSV. */
export const ORIGIN_KEYS: Record<ImprovementOrigin, string> = {
  [ImprovementOrigin.SURVEY]: 'quality.origin.survey',
  [ImprovementOrigin.COMPLAINT]: 'quality.origin.complaint',
  [ImprovementOrigin.DROPOUT]: 'quality.origin.dropout',
  [ImprovementOrigin.AUDIT]: 'quality.origin.audit',
  [ImprovementOrigin.REVIEW]: 'quality.origin.review',
  [ImprovementOrigin.OTHER]: 'quality.origin.other',
}

export const ACTION_STATUS_KEYS: Record<ImprovementStatus, string> = {
  [ImprovementStatus.PLANNED]: 'quality.actionStatus.planned',
  [ImprovementStatus.IN_PROGRESS]: 'quality.actionStatus.inProgress',
  [ImprovementStatus.DONE]: 'quality.actionStatus.done',
  [ImprovementStatus.CANCELLED]: 'quality.actionStatus.cancelled',
}

/** Couleurs d'état réservées, jamais la marque. */
export const ACTION_STATUS_VARIANTS = {
  [ImprovementStatus.PLANNED]: 'secondary',
  [ImprovementStatus.IN_PROGRESS]: 'warningSubtle',
  [ImprovementStatus.DONE]: 'successSubtle',
  [ImprovementStatus.CANCELLED]: 'outline',
} as const satisfies Record<ImprovementStatus, string>

export const RISK_STATUS_KEYS: Record<QualityRiskStatus, string> = {
  [QualityRiskStatus.OPEN]: 'quality.riskStatus.open',
  [QualityRiskStatus.MITIGATED]: 'quality.riskStatus.mitigated',
  [QualityRiskStatus.CLOSED]: 'quality.riskStatus.closed',
}

/** Les cotes de probabilité et d'impact, de 1 à 3. */
export const SCORE_KEYS: Record<1 | 2 | 3, string> = { 1: 'quality.score.low', 2: 'quality.score.medium', 3: 'quality.score.high' }

/** Gravité (probabilité × impact, 1 à 9) : élevée dès 6, modérée dès 3. */
export function severityVariant(severity: number): 'error' | 'warningSubtle' | 'secondary' {
  if (severity >= 6) return 'error'
  if (severity >= 3) return 'warningSubtle'
  return 'secondary'
}
